<template>
  <div>
    <div class=" mainLoader" v-if="loading">
      <!-- <img src="../assets/images/load.gif" width="100px"> -->
    </div>
    <div class="realbody" style="margin-bottom: 0px;">
      <div class="container ramsey">
        <div class="row">
          <div class="col-md-2 text-center">
            <img class="signman" src="../../../assets/imgs/singin_man.png"/>
          </div>
          <div class="col-md-8 signinpanel text-center">
            <p class="s_panel_title mplus2p-r spacing5-9 black mgtop10">{{ $t("ReSendVerificationLink") }}</p>
            <div class="liner">
              <hr class="halfline" style="float: left;"/>
              <span class="darkergray" style="font-size: 19px;">{{$t('OR')}}</span>
              <hr class="halfline" style="float: right;"/>
            </div>
            <form @submit.prevent="sendVerificationLink" name="form">
              <div class="form-group input text-left" :class="{ invalid: $v.email.$error && emailLostFocus }">
                <label class="mplus2p-m spacing1-2 black signlabel">{{$t('l_email')}} <span style="color: red;">*</span>
                </label>
                <input placeholder="yourname@example.com"
                       type="email"
                       class="form-control login_widget"
                       name="email"
                       v-model="$v.email.$model"
                       autofocus/>
                <div class="help-block" v-if="!$v.email.email">{{$t('r_c_email_validation')}}</div>
                <div class="help-block" v-if="!$v.email.req && emailLostFocus">{{$t('r_email_validation')}}</div>
              </div>

              <div class="form-group" style="margin-top: 40px;">
                <button  class="btn bluebtn singinbtns mplus2p-r spacing1-2"
                        style="font-size: 1.125rem; font-weight: bold;">{{$t('ReSendVerificationLink')}}
                </button>
              </div>
            </form>
            <div class="text-right" style="margin-top: 40px;">
              <router-link to="/global/user/forgot-password" class="d-block">
                                <span class="addlinks mplus2p-m spacing1-2 blue">{{$t('forgotTitle')}} &nbsp;
                                    <i class="fa fa-angle-right" aria-hidden="true"></i></span>
              </router-link>

              <p style="margin-bottom: .2rem;"></p>
              <router-link to="/global/register" class="d-block">
                                <span class="addlinks mplus2p-m spacing1-2 blue">{{$t('nextTitle')}} &nbsp;
                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                </span>
              </router-link>
            </div>
          </div>
          <div class="col-md-2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from "vuelidate";
  import {
    required,
    maxLength,
    email,
    minLength,
    sameAs
  } from "vuelidate/lib/validators";
  import axios from "axios";

  export default {
    mixins: [validationMixin],

    validations: {
      email: {req :required, email}
    },
    data() {
      return {
        loading: false,
        model: {},
        email: "",
        emailLostFocus: false,
      };
    },
    mounted() {
    },
    created() {

    },
    methods: {
      sendVerificationLink() {
        this.loading = true;
        let data = {
          email: this.email
        }
        this.$v.$touch()
        if (this.$v.$invalid) {
          this.emailLostFocus = true;
          this.loading = false;
        } else {
          axios
          .post('verify-again', data)
          .then((res) => {
            if (!res.data.result) {
              for (var i = 0; i < res.data.errors.length; i++) {
                this.$toaster.error(res.data.errors[i].message);
                if (res.data.errors[i].field === "User already verified.") {

                  this.$toaster.error(res.data.errors[i].message);
                }
                if (res.data.errors[i].field === "email") {
                  this.$toaster.error(res.data.errors[i].message);
                }
                if (res.data.errors[i].field === "password") {
                  this.$toaster.error(res.data.errors[i].message);
                }
              }
              this.loading = false;
            } else {
              this.$toaster.success(res.data.message);
              this.loading = false;
            }
          })
          .catch((error) => {
            // error
            this.loading = false;
          });
        }
        
      }
    }
  };
</script>

<style scoped>
  .input input {
    font: inherit;
    width: 100%;
    padding: 6px 12px;
    box-sizing: border-box;
    border: 1px solid #ccc;
  }

  .input.inline input {
    width: auto;
  }

  .input input:focus {
    outline: none;
    border: 1px solid #3d7dd8;
    background-color: #eee;
  }

  .input.invalid label {
    color: red;
  }

  .input.invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
  }

  .input select {
    border: 1px solid #ccc;
    font: inherit;
  }

  .slabel_panel {
    position: absolute;
    left: 56px;
  }

  .signin_label {
    font-size: 1.75rem;
    font-weight: bold;
  }

  .signin_label_jp {
    font-size: 1rem;
  }

  .ramsey {
    margin-top: 100px;
  }

  .signinpanel {
    padding: 0px 80px;
    padding-bottom: 60px;
  }
  .fbsigntext {
    font-size: 1.125rem;
    margin-left: -50px;
    font-weight: bold;
  }

  .singinbtns {
    height: 60px;
    padding: 16px;
    width: 100%;
    margin: auto;
    cursor: pointer;
    box-shadow: 0 2px 4px 0 rgba(49, 79, 147, 0.24),
    0 -2px 4px 0 rgba(49, 79, 147, 0.12);
  }

  .liner {
    height: 50px;
    padding-top: 15px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .halfline {
    width: 40%;
    border: solid 1px #788ca0;
  }

  .login_widget {
    height: 50px;
    background-color: #f0f2f4;
    border-radius: 3.2px;
    border: solid 1px #eef0f0;
  }

  .signlabel {
    font-size: 1rem;
    font-weight: 500;
  }

  .addlinks {
    font-size: 0.875rem;
    font-weight: 500;
  }

  .fa-angle-right {
    font-size: 1.2rem !important;
  }

  .fa-angle-left {
    font-size: 1.2rem !important;
  }

  .signman {
    width: 100%;
    margin-top: 430px;
  }

  @media screen and (max-width: 768px) {
    .fbsigntext {
      margin-left: 0px;
    }

    .fa-facebook {
      margin-left: 0px;
    }

    .signman {
      width: 100px;
      margin-top: 0px;
    }

    .slabel_panel {
      position: unset;
      left: 0;
      margin-top: 110px;
      margin-left: 56px;
    }

    .ramsey {
      margin-top: 0px;
    }
  }

  @media screen and (max-width: 415px) {
    .signinpanel {
      padding: 0px 10px;
      padding-bottom: 60px;
    }
  }
</style>
